import { Grid, withStyles } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import FormDefinition from '../../FormDefinition';
import { buildQaNestedFormDefinitionForest } from '../../formDefinitionTree.utils';
import { OrderReviewContext } from '../../OrderReviewContext';

const DefaultNestedFormHeader = ({
  formDefinitions,
  saveAnswersAsync,
  removeAnswersAsync,
  editPropertyCharacteristics,
}) => {
  // #region STATE
  // #endregion STATE

  // #region HOOKS
  const { state } = useContext(OrderReviewContext);
  // #endregion HOOKS

  // #region COMPUTED
  const filteredFormDefinitions = formDefinitions.filter(
    fd =>
      fd.qaFieldContext !== 'Hidden' &&
      fd.qaFieldContext !== 'Calculate Valuation' &&
      fd.questionCategoryName !== 'Order Info' 
       //&&
      // (fd.answers.some(a => a.images.length === 0) ||
        //( //(!fd.answers && state.showAllAnswers) ||
        //(fd.answers.length === 0 && state.showAllAnswers)),
  );

  const parentFormDefinitions = buildQaNestedFormDefinitionForest(filteredFormDefinitions);
  // #endregion COMPUTED

  // #region FUNCTIONS
  const determineIsReadOnlyAnswer = formDefinition => {
    if (formDefinition?.fieldContext === 'Read Only') {
      return true;
    }
    return false;
  };
  // #endregion FUNCTIONS

  // #region EFFECTS
  useEffect(() => {
    // console.log('defaultFormHeader');
  }, []);
  // #endregion EFFECTS

  return (
    <Grid container>
      <Grid item xs={12}>
        <div
          style={{
            padding: '24px 24px 0 24px',
          }}
        >
          {parentFormDefinitions
            .sort((a, b) => a.sequence - b.sequence)
            .map(fd => (
              <FormDefinition
                key={fd.formDefinitionId}
                saveAnswers={saveAnswersAsync}
                removeAnswers={removeAnswersAsync}
                formDefinition={fd}
                isReadOnly={editPropertyCharacteristics || determineIsReadOnlyAnswer(fd)}
              />
            ))}
        </div>
      </Grid>
    </Grid>
  );
};

export default DefaultNestedFormHeader;
